import { BRAND_LOGOS } from "../../data/brandLogos";

export function BrandLogosMarquee() {
  const summary = BRAND_LOGOS.map((l) => l.alt).join(", ");

  const logoSlide = (logo: (typeof BRAND_LOGOS)[number], index: number) => (
    <div
      key={`${logo.src}-${index}`}
      className="flex h-16 shrink-0 items-center justify-center px-4 md:h-20 md:px-10"
      style={{ minWidth: "160px" }}
    >
      <img
        src={logo.src}
        alt=""
        /* 
           Using loading="eager" and decoding="sync" for marquee images to prevent 
           flickering/disappearing when the browser's lazy-load logic interacts 
           with CSS transforms/masks. 
        */
        className="max-h-12 w-auto max-w-[140px] object-contain opacity-90 transition-opacity duration-300 md:max-h-16 md:max-w-[200px]"
        style={logo.scale ? { transform: `scale(${logo.scale})` } : undefined}
        loading="eager"
        decoding="sync"
        draggable={false}
      />
    </div>
  );

  return (
    <div className="relative">
      <p className="sr-only">Partner brands: {summary}</p>

      {/* 
          The marquee uses a translate3d(-50%, 0, 0) animation. 
          To be perfectly seamless with Flexbox 'gap', the track would need careful math.
          Instead, we use consistent padding (px-*) on items and no gap on the track,
          ensuring the total width of the first 50% is EXACTLY the same as the second 50%.
      */}
      <div
        className="brand-marquee-edge-fade overflow-hidden py-4 motion-reduce:hidden"
        aria-hidden
      >
        <div className="brand-marquee-track flex w-max items-center hover:[animation-play-state:paused]">
          {BRAND_LOGOS.map((logo, i) => logoSlide(logo, i))}
          {BRAND_LOGOS.map((logo, i) => logoSlide(logo, i + BRAND_LOGOS.length))}
        </div>
      </div>

      <div
        className="brand-marquee-edge-fade hidden flex-wrap items-center justify-center gap-x-8 gap-y-6 py-4 motion-reduce:flex"
        aria-hidden
      >
        {BRAND_LOGOS.map((logo, i) => logoSlide(logo, i))}
      </div>
    </div>
  );
}
